import playerReport from '../api/player-report.api'
import starReport from '../api/star-report.api'
// root state object.
// each Vuex instance is just a single state tree.
const state = {
  playerReportList: null,
  starReportList: null
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  refreshPRReports (state, allReports) {
    state.playerReportList = allReports
  },
  refreshStarReports (state, allReports) {
    state.starReportList = allReports
  },
  removePlayerReportList (state) {
    state.playerReportList = null
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  getPlayerReportListForTeamReport (context, id) {
    playerReport.api.getPlayerReportListForTeamReport(id)
      .then(response => {
        context.commit('refreshPRReports', response.data)
      },
      error => {
        console.log('impossible to load player report list from api: ')
        console.log(error)
      })
  },
  getStarReportListForTeamReport (context, id) {
    starReport.api.getStarReportListForTeamReport(id)
      .then(response => {
        context.commit('refreshStarReports', response.data)
      },
      error => {
        console.log('impossible to load player report list from api: ')
        console.log(error)
      })
  },
  getPlayerReportListForMatchReport (context, id) {
    playerReport.api.getPlayerReportListForMatchReport(id)
      .then(response => {
        context.commit('refreshPRReports', response.data)
      },
      error => {
        console.log('impossible to load player report list for match from api: ')
        console.log(error)
      })
  },
  getStarReportListForMatchReport (context, id) {
    starReport.api.getStarReportListForMatchReport(id)
      .then(response => {
        context.commit('refreshStarReports', response.data)
      },
      error => {
        console.log('impossible to load star report list for match from api: ')
        console.log(error)
      })
  },
  purgePlayerReportList (context) {
    context.commit('removePlayerReportList')
  }
}

// getters are functions
const getters = {
  playerReportList: state => {
    return state.playerReportList
  },
  starReportList: state => {
    return state.starReportList
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/player-report.js